import * as $ from "jquery";

export function setupShowButton(
    $button: JQuery,
    $items: JQuery,
    buttonsuffix?: string,
) {
    const hasItems = $items.length > 0;
    $button.prop("disabled", !hasItems);
    if (hasItems) {
        const suffix = buttonsuffix || "";
        $button.addClass("itemshidden");
        $button.on("click", function () {
            const isHidden = $button.hasClass("itemshidden");
            if (isHidden) {
                $items.show();
                $button.val("Hide" + suffix);
            } else {
                $items.hide();
                $button.val("Show" + suffix);
            }
            $button.toggleClass("itemshidden", !isHidden);
        });
    }
}

export function getParameterByName(name: string, url?: string): string | null {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;",
};

export function escapeHtml(string: string): string {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
        return entityMap[s];
    });
}

function showAlert(message: string, title?: string) {
    if (!title) {
        title = "Alert";
    }

    if (!message) {
        message = "No Message to Display.";
    }

    (<any> ($("<div></div>").html(message))).dialog({
        title: title,
        resizable: false,
        modal: true,
    });
}

$(function () {
    $(".no-access").on("click", function (evt) {
        showAlert("Management status required.");
        evt.preventDefault();
    });

    $('input[type="button"].autolinkbutton, button.autolinkbutton').each(
        function () {
            const link = $(this).data("link"); // Extract the data-link attribute

            // Attach a click event handler to the button
            $(this).on("click", function () {
                if (link) {
                    window.location.href = link; // Redirect to the link
                } else {
                    console.warn(
                        "No data-link attribute found for this button.",
                    );
                }
            });
        },
    );
});
